import Messenger from '../../components/messenger.js';

class SerialRetrieval {
  constructor($el) {
    this.$el = $el;
    this.paymentDevices = [];
    this.subscription = false;
    this.warnModal = false;
  }

  detach() {
    Messenger.off('/pinpad_retrieve', this.subscription);
  }

  _listen() {
    if (this.subscription) {
      return;
    }
    this.subscription = Messenger.on(
      '/pinpad_retrieve',
      this._checkForChanges.bind(this),
    );
  }

  _confirmSerialIDUpdate() {
    let queryURL = '/' + this.c_code + '/duplicated_serial_number',
      authorizeURL = '/' + this.c_code + '/authorize_update_serial_number',
      queryParams = JSON.stringify(this.failedSerialRetrievalIDs),
      ajaxOptions;

    if (this.warnModal !== false) {
      return;
    }

    this.warnModal = new IO.Views.Components.ConfirmationDialog({
      url: queryURL,
      template: 'payment_devices/same_serial_bulk_retrieval',
      method: 'POST',
      width: 700,
    });

    ajaxOptions = {
      type: 'POST',
      url: authorizeURL,
      data: {
        authenticity_token: $('meta[name=csrf-token]').attr('content'), // eslint-disable-line camelcase
        devices: queryParams,
        authorized: false,
      },
    };

    this.warnModal.on(
      'modalEscaped',
      function () {
        this._notifyAboutUpdate(ajaxOptions);
        this.warnModal.destroy();
        this.warnModal = false;
      }.bind(this),
    );
    this.warnModal.impact({ serials: queryParams });
    this.warnModal.answer(
      function (proceed) {
        if (proceed) {
          ajaxOptions.data.authorized = true;
        }

        this._notifyAboutUpdate(ajaxOptions);
        this.warnModal.destroy();
        this.warnModal = false;
      }.bind(this),
    );
  }
  _notifyAboutUpdate(options) {
    $.ajax(options).fail(function (response) {
      try {
        msg = JSON.parse(response.responseText).error;
      } catch {
        msg = response.statusText;
      }
      alert(msg);
    });
  }

  _checkEmptySerialID(data) {
    // This is to ensure that UI won't perform a call to check repeated serial_id when the serial id is undefined
    // or when it is an empty string
    var logEntry = _.last(data.logs);
    if (
      logEntry.received_data.serial_id === '' ||
      typeof logEntry.received_data.serial_id === 'undefined'
    ) {
      data.error = false;
      logEntry.status = 'failure';
    }
  }

  _trackRetrievalProgress(data) {
    this.processedPinPads.push(data.payment_device.id);
    if (this.c_code === undefined) {
      // eslint-disable-line camelcase
      this.c_code = data.c_code;
    } // eslint-disable-line camelcase

    // The check for empty serial_id must be done only when the field #changes is not present.
    // When #changes is present it means the backend already updated the devices and there is
    // no need to check serial_id since the changes were already applied
    if (typeof data.changes === 'undefined') {
      this._checkEmptySerialID(data);
    }

    if (data.error === true) {
      this.failedSerialRetrievalIDs.push({
        device_id: data.payment_device.id, // eslint-disable-line camelcase
        serial_id: data.logs[data.logs.length - 1].received_data.serial_id, // eslint-disable-line camelcase
      });
    }
  }

  _checkForChanges(data) {
    this._trackRetrievalProgress(data[0]);

    if (
      this.processedPinPads.length === this.pinpadIds.length &&
      this.failedSerialRetrievalIDs.length > 0
    ) {
      this._confirmSerialIDUpdate();
    }

    if (data[0].error === false) {
      _.each(data, (item) => {
        if (this.pinpadIds.indexOf(item.payment_device.id) > -1) {
          this._handlePinpadChange(item);
        }
      });
    }
  }

  _handlePinpadChange(data) {
    let logEntry = _.last(data.logs),
      state;

    if (
      logEntry.status === 'failure' ||
      _.last(data.logs).status === 'interrupted'
    ) {
      this._updateElementState(
        data.payment_device.id,
        'An error occurred',
        'error',
      );
    } else if (logEntry.status === 'success') {
      state = _.isEmpty(logEntry.updates) ? '' : 'success';
      this._updateElementState(
        data.payment_device.id,
        data.payment_device.serial_id || 'None',
        state,
      );
    } else {
      return;
    }
    this._getCheckbox(data.payment_device.id)
      .data('attr', JSON.stringify(data.payment_device))
      .trigger('change');
  }

  _getCheckbox(id) {
    const checkbox = this.$el.find(`.row-checkbox[value="${id}"]`);

    if (checkbox.length === 0) {
      return $('<input type="checkbox" class="virtual" />');
    }
    return checkbox;
  }

  _getElement(id) {
    const checkbox = this._getCheckbox(id);

    if (checkbox.hasClass('virtual')) {
      return $('<span></span>');
    }
    return checkbox.parents('tr').find('td:eq(6)').find('a');
  }

  _updateElementState(id, message, state = '') {
    var currentClasses = `noClick ${state}`,
      duplicate;

    if (state === 'success') {
      duplicate = $($(`td > a:contains("${message}")`).first());
      duplicate.removeClass().addClass(currentClasses).text('None');
    }

    this._getElement(id).removeClass().addClass(currentClasses).text(message);
  }

  _showLoader() {
    _.each(this.paymentDevices, (item) =>
      this._updateElementState(item.id, 'Retrieving...'),
    );
  }

  process(response) {
    if (this._processDuplicateIps(response)) {
      return;
    }

    $.ajax({
      type: 'POST',
      url: response.baseURL + '/retrieve_pinpad_data',
      data: {
        authenticity_token: $('meta[name=csrf-token]').attr('content'), // eslint-disable-line camelcase
        select_all: response.selectedAll, // eslint-disable-line camelcase
        payment_device_ids: response.selected.join(','), // eslint-disable-line camelcase
      },
    }).done((data) => {
      this.paymentDevices = data;
      this.pinpadIds = _.map(this.paymentDevices, (i) => i.id);
      this.processedPinPads = [];
      this.failedSerialRetrievalIDs = [];
      this.c_code = undefined; // eslint-disable-line camelcase
      this._listen();
      this._showLoader();
    });
  }

  _processDuplicateIps(response) {
    var duplicateData = this._duplicateIpData(response.selected);

    if (_.isEmpty(duplicateData.duplicateIps)) {
      return false;
    }

    this._showDuplicateIpsWarning(duplicateData);
    return true;
  }

  _showDuplicateIpsWarning(duplicateData) {
    var infoModal = new IO.Views.InformationModal({
        el: '#information-modal',
        closable: true,
      }),
      duplicateMsg = infoModal.renderTemplate(
        duplicateData,
        'payment_devices/duplicate_pinpad_ip_bulk_retrieval',
      );

    infoModal.show(duplicateMsg);
  }

  _duplicateIpData(selectedDevices) {
    var REGISTER_NUMBER_INDEX = 2,
      DEVICE_IP_INDEX = 3,
      duplicateIps = {},
      deviceData,
      registerNumber,
      deviceIp;

    _.each(selectedDevices, (deviceId) => {
      deviceData = $(`input.row-checkbox[value="${deviceId}"]`).data('attr');

      if (deviceData.constructor.name === 'Array') {
        registerNumber = deviceData[REGISTER_NUMBER_INDEX];
        deviceIp = deviceData[DEVICE_IP_INDEX];
      } else if (deviceData.constructor.name === 'String') {
        deviceData = JSON.parse(deviceData);
        registerNumber = deviceData.register_number;
        deviceIp = deviceData.device_ip;
      } else {
        return;
      }

      if (deviceIp in duplicateIps) {
        duplicateIps[deviceIp].push(registerNumber);
      } else {
        duplicateIps[deviceIp] = [registerNumber];
      }
    });

    _.each(duplicateIps, (registerNumbers, ip) => {
      if (registerNumbers.length === 1) {
        delete duplicateIps[ip];
      }
    });

    return { duplicateIps: duplicateIps };
  }
}

module.exports = SerialRetrieval;
